import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Watch from "@/pages/Watch";
import Channel from "@/pages/Channel";
import Search from "@/pages/Search";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="yt-grain" aria-hidden="true" />
        <div className="yt-page">
          <Header />
          <div className="yt-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/watch/:videoId" element={<Watch />} />
              <Route path="/channel" element={<Channel />} />
              <Route path="/search" element={<Search />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
